import { AHText } from "arkh";

export function OrgTableTitle(props: { children: React.ReactNode }) {
  return (
    <AHText numberOfLines={1} style={{ flex: 1 }} type="subtitle">
      {props.children}
    </AHText>
  );
}
